import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { showSuccessToast } from 'utils/toast';

/**
 * RTK Query Toast Middleware
 * Automatically shows toast notifications for successful mutations
 * 
 * Note: Error toasts are handled automatically in baseQuery (apiSlice.js)
 * This middleware only handles success messages for mutations that return a message
 */

export const toastMiddleware = createListenerMiddleware();

// Listen for fulfilled mutations that have success messages
toastMiddleware.startListening({
  matcher: (action) => {
    // Match RTK Query fulfilled mutation actions
    return action.type.endsWith('/fulfilled') && 
           action.type.includes('/mutations/');
  },
  effect: async (action, listenerApi) => {
    // Skip if explicitly disabled
    if (action.meta?.arg?.originalArgs?.skipToast) {
      return;
    }

    const response = action.payload;
    
    // Check if response has a success message
    const message = response?.message || response?.data?.message;
    
    // Only show success toast if there's a message
    // This prevents showing toasts for queries (GET requests) and silent operations
    if (message) {
      showSuccessToast(response);
    }
  },
});

